@if (request.peakSeasonWarning) {
<div class="row move-up">
  <div class="col-xl-12 col-6">
    <div class="text-warning peak-season">{{request.peakSeasonWarning}}</div>
  </div>
</div>
}

@if (request.isViewOnly) {
<div style="color:#6E6E6E;margin-bottom:25px;">{{localize(langSection.Role, langText.ViewOnly)}}</div>
}
@if (request.requestStatus !== 'Canceled' && request.requestStatus !== 'Canceling' && request.requestStatus !== 'Rejected') {
<div class="row">
  <div class="col p-0 seperator-after">
    @if (isStatusComplete('Approved') || isStatusActive('Approved')) {
<span class="bg-green-badge text-white rounded-circle">&#10003;</span>
}
    @if (isStatusPending('Approved')) {
<span class="rounded-circle bg-gray">1</span>
}
  </div>
  <div class="col separator p-0">
    @if (isStatusComplete('Scheduled') || isStatusActive('Scheduled')) {
<span class="bg-green-badge text-white rounded-circle">&#10003;</span>
}
    @if (isStatusPending('Scheduled')) {
<span class="rounded-circle bg-gray">2</span>
}
  </div>
  <div class="col separator p-0">
    @if (isStatusComplete('In Transit')) {
<span class="bg-green-badge text-white rounded-circle">&#10003;</span>
}
    @if (isStatusActive('In Transit')) {
<div class="rounded-circle bg-orange"><strong>3</strong></div>
}
    @if (isStatusPending('In Transit')) {
<span class="rounded-circle bg-gray">3</span>
}
  </div>
  <div class="col separator p-0">
    @if (isStatusComplete('On Property')) {
<span class="bg-green-badge text-white rounded-circle">&#10003;</span>
}
    @if (isStatusActive('On Property')) {
<div class="rounded-circle bg-orange"><strong>4</strong></div>
}
    @if (isStatusPending('On Property')) {
<span class="rounded-circle bg-gray">4</span>
}
  </div>
  <div class="col p-0 seperator-before">
    @if (isStatusComplete('Completed')) {
<span class="bg-green-badge text-white rounded-circle">&#10003;</span>
}
    @if (isStatusPending('Completed')) {
<div class="bg-gray rounded-circle align-text-top">5</div>
}
  </div>
</div>
}
@if (request.requestStatus !== 'Canceled' && request.requestStatus !== 'Canceling' && request.requestStatus !== 'Rejected') {
<div class="row">
  <div class="col small">
    {{localize(langSection.TrailerCard, langText.Approved)}}
  </div>
  <div class="col small">
    {{localize(langSection.TrailerCard, langText.Scheduled)}}
  </div>
  <div class="col small">
    {{localize(langSection.TrailerCard, langText.InTransit)}}
  </div>
  <div class="col small">
    {{localize(langSection.TrailerCard, langText.OnProperty)}}
  </div>
  <div class="col small">
    {{localize(langSection.TrailerCard, langText.Complete)}}
  </div>
</div>
}
@if (request.requestStatus === 'Canceled') {
<div class="row">
  <div class="col">
    {{localize(langSection.RequestDetailsPage, langText.Canceled)}}<br /><br />
    {{cancelReason}}
  </div>
</div>
}
@if (request.requestStatus === 'Canceling') {
<div class="row">
  <div class="col">
    {{localize(langSection.RequestDetailsPage, langText.Canceling)}}...<br /><br />
    {{cancelReason}}
  </div>
</div>
}
@if (request.requestStatus === 'Rejected') {
<div class="row">
  <div class="col">
    {{localize(langSection.RequestRejection, langText.NotFulfilled)}}<br /><br />
    {{rejectionReason}}
  </div>
</div>
}
